module.exports = __webpack_public_path__ + "img/152.5c49fd3b.jpg";